import { isFeatureEnabled } from 'owa-feature-flags';

export interface SettingsPath {
    category: string;
    subcategory: string;
}
export function getCopilotSettingsPath(): SettingsPath {
    if (isFeatureEnabled('mon-copilot-user-preferences')) {
        return {
            category: 'copilot',
            subcategory: 'control',
        };
    } else {
        return {
            category: 'mail',
            subcategory: 'copilot',
        };
    }
}

export function getCopilotPrioritizeSettingsPath(): SettingsPath {
    if (isFeatureEnabled('mon-copilot-user-preferences')) {
        return {
            category: 'copilot',
            subcategory: 'prioritize',
        };
    } else {
        return {
            category: 'mail',
            subcategory: 'copilot',
        };
    }
}
